import React from 'react';
import { motion } from 'framer-motion';
import { textItem } from '../Form/animation';
interface HeadingProps {
  text?: string;
  className?: string;
}

function TeamHeading({ text, className }: HeadingProps) {
  return (
    <motion.div
      variants={textItem}
      className={`px-2 text-[22px] font-bold leading-none text-brand md:text-2xl md:text-brand lg:text-2xl ${className}`}
    >
      {text &&
        text.split('\n').map((line: string, index: number) => (
          // variants={textAnimation} initial="offscreen" whileInView="onscreen"
          <motion.p key={index}>{line}</motion.p>
        ))}
    </motion.div>
  );
}

export default TeamHeading;
